import type { CSSProperties } from "react";
import styled, { css as styledComponentsCss } from "styled-components";
import { Heading } from "@viagogo/core/ui";
import { FavoritesButtonWithCount } from "src/website-apps/shared/components/FavoritesV2Buttons/FavoritesV2Button/FavoritesButtonWithCount";
import { SharingIcon } from "src/website-apps/shared/components/stubhub-sharing";

export const StyledHeadingSmallerTitleFont = styled(Heading)`
  margin-top: ${(props) => props.theme.spacing(0)};
  margin-bottom: ${(props) => props.theme.spacing(0)};
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.title1)};

  @media ${({ theme: { media } }) => media.phone} {
    ${({
      theme: {
        typography: { getStyles, variant },
      },
    }) => getStyles(variant.title1)};
  }
`;

export const PerformerGenresDiv = styled.div`
  // match height of both children to make sure icon centered.
  display: grid;
  grid-template-columns: auto 1fr;
  gap: ${(props) => props.theme.spacing(1)};
  @media ${({ theme: { media } }) => media.phone} {
    gap: ${(props) => props.theme.spacing(2)};
  }
  color: ${(props) => props.theme.colors.textPrimary};
  text-transform: capitalize;
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.subtitle2)};
`;

export const MusicNoteIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ButtonsContainer = styled.div<{
  $width?: number;
  $marginTop?: number;
}>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: ${(props) => (props.$marginTop === undefined ? props.theme.spacing(1) : `${props.$marginTop}px`)};
  gap: ${(props) => props.theme.spacing(2)};
  @media ${({ theme: { media } }) => media.phone} {
    min-width: 36px;
  }
  position: relative;
  ${({ $width }) =>
    $width &&
    styledComponentsCss`
      width: ${$width}px;
    `}
`;

export const ShareButton = styled(SharingIcon)`
  width: 32px;
  height: 32px;
  background: ${({ theme }) => theme.colors.backgroundPrimary};

  & > svg {
    margin-left: 1px;
  }

  @media ${({ theme: { media } }) => media.phone} {
    width: 38px;
    height: 38px;
    border: 1px solid ${(props) => props.theme.colors.borderPrimary};
  }
`;

export const StyledPortalFavoritesButtonV2 = styled(FavoritesButtonWithCount)<{
  $right?: number;
  $position?: CSSProperties["position"];
  $onTransparent?: boolean;
}>`
  margin: 0;
  ${({ $right }) =>
    $right &&
    styledComponentsCss`
      right: ${$right}px;
    `}
  position: ${({ $position }) => $position ?? "absolute"};
  background-color: transparent;
  top: 20px;
  height: 32px;
  div > svg {
    height: 30px;
    max-width: 30px;
    fill: none;
    cursor: pointer;

    > rect {
      fill: none;
    }

    > path {
      fill: ${({ $onTransparent, theme }) =>
        $onTransparent ? theme.palette.textOnNeutralSecondary : theme.palette.textOnNeutralPrimary};
    }
  }

  p {
    color: ${({ $onTransparent, theme }) =>
      $onTransparent ? theme.palette.textOnNeutralSecondary : theme.palette.textOnNeutralPrimary};
  }
`;

export const StyledPortalShareButton = styled(ShareButton)<{
  $topOffset?: number;
  $onTransparent?: boolean;
}>`
  position: absolute;
  background-color: transparent;
  top: 20px;
  height: 32px;
  max-width: 32px;
  > svg {
    height: 32px;
    max-width: 32px;
    fill: none;
    cursor: pointer;

    > rect {
      fill: none;
    }

    > path {
      stroke: none;
      fill: ${({ $onTransparent, theme }) =>
        $onTransparent ? theme.palette.textOnNeutralSecondary : theme.palette.textOnNeutralPrimary};
    }
  }
`;
